module.exports = __webpack_public_path__ + "static/media/vvs_secy.131de2e9.jpg";